// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qtYR","newExpiryDate":"styles_newExpiryDate__11CMq","footer":"styles_footer__2cBB_"};